import { ClientAppEntry, clientAppRouteName } from '@/apps/clientAppRegistry'

export const VIEW_ID = 'brelag-admin'

export const CLIENT_APP: ClientAppEntry = {
  name: 'Brelag Admin',
  path: 'brelag-admin',
  icon: 'mdi-domain',
  defaultPathName: 'mandator-list',
}

export function brelagAdminRouteName(routeName: string) {
  return clientAppRouteName(VIEW_ID, routeName)
}
